import { render, staticRenderFns } from "./scale-screen.vue?vue&type=template&id=219608aa&scoped=true"
import script from "./scale-screen.vue?vue&type=script&lang=js"
export * from "./scale-screen.vue?vue&type=script&lang=js"
import style0 from "./scale-screen.vue?vue&type=style&index=0&id=219608aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219608aa",
  null
  
)

export default component.exports